<template>
  <AppLayout :show-app-preview="false">
    <template #default>
      <MultiStepForm :components="stepsComponents"/>
      <AppPopIn :opened="isPopInOpened" @close="isPopInOpened = false">
        <h1>Professionnels de santé, créez un compte et activez votre essai gratuit&nbsp;!</h1>
        <p>Simplifiez le suivi de vos patients avec le cabinet médical connecté Hellocare.</p>
        <p>
          Proposez la prise de RDV en ligne, réalisez des téléconsultations facilement, partagez des documents de santé
          et bien d'autres choses encore.
        </p>
        <p class="cta">
          <ButtonGreen @click="isPopInOpened = false">Continuer</ButtonGreen>
        </p>
      </AppPopIn>
    </template>
    <template #footer>
      <div class="registration">
        <router-link :to="{ name: 'login' }">
          J'ai déjà un compte professionnel de santé
        </router-link>
      </div>
    </template>
  </AppLayout>
</template>

<script>
  import MultiStepForm from '@/components/MultiStepForm';
  import AppLayout from '@/components/AppLayout';
  import AppProgress from '@/components/AppProgress';
  import Authentication from '@/components/Signup/SignupAuthentication';
  import ProfessionalType from '@/components/Signup/SignupProfessionalType';
  import Identification from '@/components/Signup/SignupIdentification';
  import Identity from '@/components/Signup/SignupIdentity';
  import Practice from '@/components/Signup/SignupPractice';
  import Phone from '@/components/Signup/SignupPhone';
  import AuthCode from '@/components/Signup/SignupAuthCode';
  import AppPopIn from '@/components/AppPopIn';
  import ButtonGreen from '@/components/ButtonGreen';

export default {
  name: 'SignupPage',
  components: {ButtonGreen, AppPopIn, AppProgress, AppLayout, MultiStepForm},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!from.name) {
        vm.isPopInOpened = true;
      }

    });
  },
  data() {
    return {
      isPopInOpened: false,
    };
  },
  computed: {
    stepsComponents: function () {
      return [
        ProfessionalType,
        ...(this.$store.state.signup.form.type !== "secretary" ? [Identification] : []),
        Identity,
        Practice,
        Authentication,
        Phone,
        AuthCode,
      ];
    },
  },
};
</script>


<style lang="scss" scoped>
.app-pop-in {
  text-align: center;

  p {
    font-family: $_fontRoboto;
    font-size: 1.8rem;

    &.cta {
      margin-top: 6rem;
    }
  }
}

.registration {
  text-align: right;

  a {
    font-size: 1.5rem;
    color: $textColor;
  }
}
</style>
